import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockSmallIconsSliderScript() {
  document.addEventListener( 'DOMContentLoaded', function () {
    const blocksSmall = document.querySelectorAll('.smallIcons__sliders');
  
    blocksSmall.forEach(block=>{
       let smallIcon = new Splide(block, {
          type  : 'loop',
          rewind: true,
          autoplay: true,   
          perPage: 6,
          gap: 40,
          perMove: 1,
          pagination:false,
          arrows: false,
          interval: 0,
          speed: 8000,
          breakpoints: {
            992: { perPage: 3 },
            599: { perPage: 2 },
          },
        });

        smallIcon.mount()
    });
  })
}